"use client";

import { useEffect, useState } from "react";

import { cn } from "@repo/ui/lib/utils";

interface LocalAppBadgeProps {
  appName: string;
  className?: string;
}

export default function LocalAppBadge({ appName, className }: Readonly<LocalAppBadgeProps>) {
  const [host, setHost] = useState<string | null>(null);

  useEffect(() => {
    if (process.env.NODE_ENV !== "development") {
      return;
    }

    const { hostname, host: currentHost } = window.location;
    if (hostname !== "localhost" && hostname !== "127.0.0.1" && hostname !== "0.0.0.0") {
      return;
    }

    setHost(currentHost);
  }, []);

  if (!host) {
    return null;
  }

  return (
    <div
      className={cn(
        "inline-flex items-center rounded-full border border-white/40 bg-black/55 px-3 py-1 text-[10px] font-semibold uppercase tracking-[0.22em] text-white shadow-lg backdrop-blur-sm sm:text-[11px]",
        className,
      )}
    >
      {appName} • {host}
    </div>
  );
}
